import { render } from "./ItemsManager.vue?vue&type=template&id=36bb3b78&scoped=true&ts=true"
import script from "./ItemsManager.vue?vue&type=script&lang=ts"
export * from "./ItemsManager.vue?vue&type=script&lang=ts"

import "./ItemsManager.vue?vue&type=style&index=0&id=36bb3b78&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bb3b78"]])

export default __exports__